/**
 * 客户端通信bridge
 */
import useragent from '@common/useragent'

/**
 * 不是直接location.href = uri，
 * 是因为在Ios浏览器里面连续短时间两次设置location.href，
 * 会导致浏览器认为应该location到后面那次，
 * 后面那次覆盖掉了前面那次请求
 */
const _call = (uri) => {
  if (useragent.isAndroid && useragent.isKaniu) {
    // 卡牛客户端问题，回退在部分机型无法加载iframe中的url scheme
    window.location.href = uri
  } else {
    const iframe = document.createElement('iframe')
    iframe.src = uri
    iframe.style.display = 'none'
    document.body.appendChild(iframe)
    const cb = () => {
      setTimeout(() => {
        document.body.removeChild(iframe)
      }, 1000)
    }
    iframe.onload = cb
    iframe.onerror = cb
  }
}

/**
 * 随手记协议拼接方法
 * @MethodName：方法名
 * @JSONParamString：参数
 * @CallBackName：回调函数
 * @ExtraString：其他信息
 */
export const uriSuishouji = (MethodName, JSONParamString, CallBackName, ExtraString) => {
  const cmd = `feidee://Market/${MethodName}`
  const params = []
  if (JSONParamString) {
    params.push(`p=${encodeURIComponent(JSON.stringify(JSONParamString))}`)
  }
  if (CallBackName) {
    params.push(`cb=${CallBackName}`)
  }
  if (ExtraString) {
    params.push(`e=${ExtraString}`)
  }
  const uri = cmd + (params.length > 0 ? '?' + params.join('&') : '')
  return uri
}

/**
 *
 * 随管家协议拼接方法
 * @param {string} uri - 地址
 * @param {object} [JsonParam] - 参数
 * @param {string} [CallBackName] - 回调方法名
 */
export const uriSuiguanjia = (uri, JsonParam = {}, CallBackName) => {
  const params = []
  const keys = Object.keys(JsonParam)

  keys.forEach((k) => {
    let value = JsonParam[k]
    if (typeof value === 'object') {
      value = JSON.stringify(value)
    }
    value = encodeURIComponent(value)
    params.push(`${k}=${value}`)
  })

  if (CallBackName) {
    params.push(`cb=${CallBackName}`)
  }

  return uri + (params.length > 0 ? '?' + params.join('&') : '')
}

/**
 * H5与客户端通信桥，适用于随手记，卡牛
 * @param {string} uri
 * @param {string} [callbackName]
 * @param {function} [callback]
 * @param {boolean} [isClear] 是否清清除原方法
 */
export const call = (uri, callbackName, callback, isClear = true) => {
  if (callbackName) {
    const origin = window[callbackName]
    window[callbackName] = (...argv) => {
      isClear && (window[callbackName] = origin)
      callback.call(null, ...argv)
    }
  }
  _call(uri)
}

export default {
  call,
  uriSuishouji,
  uriSuiguanjia,
}



// WEBPACK FOOTER //
// ./node_modules/@finance/ssvue/node_modules/@common/client/src/bridge.js